import router from './router';
import store from './store';

// export default router;
export { router, store };



// WEBPACK FOOTER //
// ./src/app/index.js